import React, { useState } from "react";
// import { Facebook, Twitter, Linkedin, Link as LinkIcon, Printer, Mail } from "lucide-react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaLink, FaPrint, FaEnvelope } from "react-icons/fa";


export default function SocialShare({
  url,
  title,
  className
}: {
  url: string;
  title?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title ?? "");

  const openWindow = (u: string) => {
    window.open(u, "_blank", "noopener,noreferrer,width=640,height=480");
  };

  // const handleFacebook = () =>
  //   openWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
  const handleFacebook = () => {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // Try to open in Facebook app
    window.location.href = `fb://facewebmodal/f?href=${shareUrl}`;
    // Fallback: open in browser after short delay
    setTimeout(() => openWindow(shareUrl), 500);
  } else {
    openWindow(shareUrl);
  }
};

  const handleTwitter = () => {
  const shareUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = `twitter://post?message=${encodedTitle}%20${encodedUrl}`;
    setTimeout(() => openWindow(shareUrl), 500);
  } else {
    openWindow(shareUrl);
  }
};

  const handleLinkedIn = () => {
  const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = `linkedin://shareArticle?mini=true&url=${encodedUrl}`;
    setTimeout(() => openWindow(shareUrl), 500);
  } else {
    openWindow(shareUrl);
  }
};

  const handleEmail = () => {
    const subject = title ? `Check this out: ${title}` : "Check this out";
    const body = `${title ? title + "\n" : ""}${url}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
      const el = document.createElement("textarea");
      el.value = url;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handlePrint = () => window.print();

  return (
    <div className={`flex items-center gap-2 social-share-bar ${className ?? ""}`}>
      {/* <span className="text-sm text-gray-600 mr-2 hidden md:inline">Share</span> */}

      {/* Social share buttons: subtle, clean, branded accent on icon only */}
      <button
        aria-label="Share on Facebook"
        onClick={handleFacebook}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black    transition-colors duration-200"
        title="Facebook"
      >
        <FaFacebookF size={16} className="text-white group-hover:text-white" />
      </button>

      <button
        aria-label="Share on Twitter"
        onClick={handleTwitter}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black transition-colors duration-200"
        title="Twitter"
      >
        <FaTwitter size={16} className="text-white group-hover:text-white" />
      </button>

      <button
        aria-label="Share on LinkedIn"
        onClick={handleLinkedIn}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black transition-colors duration-200"
        title="LinkedIn"
      >
        <FaLinkedinIn size={16} className="text-white group-hover:text-white" />
      </button>

      <button
        aria-label="Share via Email"
        onClick={handleEmail}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black transition-colors duration-200"
        title="Email"
      >
        <FaEnvelope size={16} className="text-white group-hover:text-white" />
      </button>

      {/* Utility buttons: neutral, less visual weight */}
      <button
        aria-label="Copy link"
        onClick={handleCopy}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black transition-colors duration-200"
        title="Copy link"
      >
        <FaLink size={16} className="text-white group-hover:text-white" />
      </button>

      <button
        aria-label="Print page"
        onClick={handlePrint}
        className="btn group flex items-center justify-center w-9 h-9 rounded-full bg-harvey-red shadow-sm hover:bg-black transition-colors duration-200"
        title="Print"
      >
        <FaPrint size={16} className="text-white group-hover:text-white" />
      </button>

      {/* small status */}
      <div
        aria-hidden
        className={`ml-2 text-sm transition-opacity duration-200 ${copied ? "opacity-100" : "opacity-0"} text-gray-600`}
      >
        {copied ? "Copied!" : ""}
      </div>
    </div>
  );
}
